import React, { useState } from "react";
import Header from "../Shard/Navbar/Header";
import SearchHeading from "./HomePages/Search/SearchHeading";
import Service from "./Service/Service";
import VideoPlayer from "./VideoPlayer/VideoPlayer";
import "./Home.css";
import Vehicle from "./Vehicle/Vehicle";
import ShipWith from "./ShipWith/ShipWith";
import Client from "./Clients/Client";
import Articles from "./Articles/Articles";

const Home = ({
  isShaw,
  setIsShaw,
  modalOpen,
  setModalOpen,
  setLoginModalOpen,
}) => {
  console.log("home", modalOpen);
  return (
    <div className="homepage">
      <Header
        isShaw={isShaw}
        setIsShaw={setIsShaw}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        setLoginModalOpen={setLoginModalOpen}
      />
      <SearchHeading />
      <Service />
      <Vehicle />
      <VideoPlayer />
      <ShipWith />
      <Client />
      <Articles />
    </div>
  );
};

export default Home;
